

import sizechartubless from './images/sizecahrtubless.jpg'
import ActiveRight from './images/Active-Right.svg'
import InactiveLeft from './images/InActive-Left.svg'

const assets  = {


    sizechartubless,

    ActiveRight,
    InactiveLeft,

};
export default assets;